<div class="priority-details">

    <div *ngIf="priority.value.id !== null || editMode" class="title-header">
        <div class="title-left">
            <span class="material-icons-outlined">flag</span>
            <span class="title-text">{{ priorityTitle | translate }}</span>
        </div>
        <div class="header-buttons" *ngIf="supervisor">
            <ng-container *ngIf="!editMode">
                <button class="btn-edit" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">edit</span>
                </button>
                <button class="btn-delete" (click)="deletePriority()">
                    <span class="material-icons-outlined">delete</span>
                </button>
            </ng-container>
            <ng-container *ngIf="editMode">
                <action-button
                    class="btn-save"
                    (actionEvent)="savePriority($event)"
                    icon="save">
                </action-button>
                <button class="btn-cancel" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">cancel</span>
                </button>
            </ng-container>
        </div>
    </div>

    <div *ngIf="priority.value.id === null && !editMode" class="empty-details">
        <span class="material-icons-outlined">flag</span>
    </div>

    <div *ngIf="priority.value.id !== null || editMode" class="priority-info-container">

        <div *ngIf="priority.value.id !== null && !editMode" class="priority-info">
            <table>
                <tr class="info-row">
                    <td><strong class="label">{{ "priorityDetails.nameLabel" | translate }}</strong></td>
                    <td><span class="value">{{ priority.value.value }}</span></td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "priorityDetails.colorLabel" | translate }}</strong></td>
                    <td>
                        <div class="color-row">
                            <span class="color-swatch" [style.background-color]="priority.value.color"></span>
                            <span class="value">{{ priority.value.color }}</span>
                        </div>
                    </td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "priorityDetails.importanceLabel" | translate }}</strong></td>
                    <td>
                        <span class="importance-badge">{{ priority.value.importance }}</span>
                    </td>
                </tr>
            </table>

            <messages
                [form]="priorityForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE">
            </messages>
        </div>

        <form [formGroup]="priorityForm" *ngIf="editMode" class="priority-form">
            <div class="form-group">
                <label for="name">{{ "priorityDetails.nameLabel" | translate }}</label>
                <input type="text" id="name" formControlName="name" />
                <messages [form]="priorityForm" [messagesObserver]="messages" fieldname="name"></messages>
            </div>

            <div class="form-group">
                <label for="color">{{ "priorityDetails.colorLabel" | translate }}</label>
                <div class="color-picker-row">
                    <input type="color" id="color" formControlName="color" class="color-input" />
                    <span class="color-value">{{ priorityForm.value.color }}</span>
                </div>
            </div>

            <div class="form-group">
                <label>{{ "priorityDetails.importanceLabel" | translate }}</label>
                <div class="radio-group">
                    <label *ngFor="let num of [1, 2, 3, 4, 5]" class="radio-pill"
                           [class.radio-pill-selected]="priorityForm.value.importance === num">
                        <input type="radio" [value]="num" formControlName="importance" />
                        {{ num }}
                    </label>
                </div>
            </div>

            <messages
                [form]="priorityForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE">
            </messages>
        </form>

    </div>
</div>
